import axios from "axios";
import {alertResponseMessage, errorResponse} from "./response";
// import config from './../../config/api';
// import token from './../../config/token';
const apiBaseUrl = process.env.REACT_APP_API_URL;//Admin
const apiBaseMainUrl = process.env.REACT_APP_API_URL_MAIN;
const headers = {
  'Content-Type': 'application/json',
  'Authorization': localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : ""
};
/*
 * Fetch Details by Get Method
 */
export const get_api_call = async (api, payload, notify_error=true, api_type="") => {
  // console.log(payload, 'payloadpayload')
  var response = {status : 500, data: {}};
  try{
    // console.log(headers, 'headers')
    // await token.setAxiosHeaderToken();
    var data = {};
    if(api_type){
      data = await axios.get(`${apiBaseUrl}/${api}`,
                                  {params: payload,
                                  headers,
                                  responseType: api_type});
      data.data.status = 200;
    }else{
      data = await axios.get(`${apiBaseUrl}/${api}`,
                                  {params: payload,
                                  headers});
    }

    return data.data;
  }catch(error){
      console.log(error, 'eeeeeeee')
    // return cb(response);
    if(notify_error){
      return errorResponse({error, alert_error: 1});
    }else{
      return response;
    }
  }
};
/*
 * Fetch Details by Get Method for pdf sownload
 */
export const get_pdf_api_call = async (api, payload) => {
  var response = {status : 500, response: {}};
  try{
    const apiData = await axios({
        url: `${apiBaseUrl}/${api}`, 
        method: 'GET',
        params: payload,
        responseType: 'blob',
        headers
        // headers: {
        //           Authorization: localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : "",
        //           // Accept: 'application/pdf'
        //       },
    });

    response.status = 200;
    response.response = apiData;
    return response;
  }catch(error){
      console.log(error, 'eeeeeeee')
      return response;
  }
};
/*
 * Fetch Details by Get Method:Main API
 */
export const get_api_call_main = async (api, payload, notify_error=true) => {
  // console.log(payload, 'payloadpayload')
  var response = {status : 500, data: {}};
  try{
    // console.log(headers, 'headers')
    // await token.setAxiosHeaderToken();
    const data = await axios.get(`${apiBaseMainUrl}/${api}`,
                                  {params: payload,
                                  headers});
    return data.data;
  }catch(error){
      console.log(error, 'eeeeeeee')
    // return cb(response);
    if(notify_error){
      return errorResponse({error, alert_error: 1});
    }else{
      return response;
    }
  }
};
/*
 * Fetch Details by Post Method
 */
export const post_api_call = async(api, payload, notify_error=true, api_type="") => {
//   var response = {status : 500, data: {}};
  // console.log(api)
  try{
        // await token.setAxiosHeaderToken();
    // token.setAxiosHeaderToken({}, async cb_token => {
      var data = {};
      if(api_type){
        data = await axios.post(`${apiBaseUrl}/${api}`,
                                    payload,
                                    {headers,
                                    responseType: api_type});
        data.data.status = 200;
      }else{
        data = await axios.post(`${apiBaseUrl}/${api}`,
                                    payload,
                                    {headers});
      }
        // const data = await axios.post(`${apiBaseUrl}/${api}`, payload, {headers});
      return data.data;
    //   axios({
    //     method: 'POST',
    //     url: `${apiBaseUrl}${api}`,
    //     data: payload,
    //   }).then(res => {
    //     const { data } = res;
    //     if(typeof data.status !== "undefined" 
    //       && data.status === 200
    //     ){
    //       response.status = 200;
    //     }
    //     response.data = data;
    //     return cb(response);
    //   })
    //   .catch(error => {
    //     if (error.response) {
    //       response.data = error.response.data;
    //       response.status = error.response.status;
    //     }
    //     return cb(response);
    //   });
    // });
  }catch(error){
    if(!(typeof payload.fetch_type !== "undefined"
      && payload.fetch_type === 'logout')
    ){
      // throw error; 
      return errorResponse({error, alert_error: 1});
    }
    console.log(error)
    // return cb(response);
    return;
  }
};
/*
 * Fetch Details by Post Method:Main API
 */
export const post_api_call_main = async(api, payload, notify_error=true) => {
  //   var response = {status : 500, data: {}};
    // console.log(api)
    try{
          // await token.setAxiosHeaderToken();
      // token.setAxiosHeaderToken({}, async cb_token => {
          const data = await axios.post(`${apiBaseMainUrl}/${api}`, payload, {headers});
          // console.log(data)
          return data.data;
      //   axios({
      //     method: 'POST',
      //     url: `${apiBaseUrl}${api}`,
      //     data: payload,
      //   }).then(res => {
      //     const { data } = res;
      //     if(typeof data.status !== "undefined" 
      //       && data.status === 200
      //     ){
      //       response.status = 200;
      //     }
      //     response.data = data;
      //     return cb(response);
      //   })
      //   .catch(error => {
      //     if (error.response) {
      //       response.data = error.response.data;
      //       response.status = error.response.status;
      //     }
      //     return cb(response);
      //   });
      // });
    }catch(error){
      if((!(typeof payload.fetch_type !== "undefined"
        && payload.fetch_type === 'logout'))
        && notify_error
      ){
          return errorResponse({error, alert_error: 1});
      }
      console.log(error)
      // return cb(response);
      return;
    }
  };
/*
 * Call Error API
 */
export const error_api_call = async(payload) => {
    try{
      await axios.post(`${apiBaseUrl}/app-error`, {app: 'website', error: payload.error}, {headers});
      return 'Api Called';
    }catch(error){
      console.log(error)
      return 'Api Called:Error';
    }
  };
//Download Sample File
export const downloadSampleFile = async(e, type="", api_url, file_name) => {
  try{
      e.preventDefault();
      e.target.disabled = true;
      const appiData = await post_api_call(api_url, {}, true, 'blob');
      if(appiData.status === 200){
        // Create a Blob URL
        const url = window.URL.createObjectURL(new Blob([appiData]));
        // Create a temporary <a> to trigger download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${file_name}.xlsx`); // 👈 desired filename
        document.body.appendChild(link);
        link.click();
        // Clean up
        link.remove();
        window.URL.revokeObjectURL(url);
      }
      e.target.disabled = false;
      return '';
  }catch(error){
    console.log(error)
    e.target.disabled = false;
    alertResponseMessage({alert_type: 2, message: "Error Downloading Sample File"});
    error_api_call({error: `admin|action|action-creators|downloadSampleFile|${error}`});
    return false;
  }
}
//Download Blob to File
export const downloadBlobCreatedFile = async(apiExcelData, fileName) => {
  try{
    // Create a Blob URL
    const url = window.URL.createObjectURL(new Blob([apiExcelData]));
    // Create a temporary <a> to trigger download
    const link = document.createElement('a');
    link.href = url;
    const currentTime = new Date().toLocaleString().replace(',','').replace(' ','');
    // link.setAttribute('download', `Failed-Opportunity-Data-${currentTime}.xlsx`);
    link.setAttribute('download', `${currentTime}-${fileName}`);
    document.body.appendChild(link);
    link.click();
    // Clean up
    link.remove();
    window.URL.revokeObjectURL(url);
    return '';
  }catch(error){
    console.log(error)
    alertResponseMessage({alert_type: 2, message: "Error Downloading File"});
    error_api_call({error: `admin|action|action-creators|downloadBlobCreatedFile|${error}`});
    return false;
  }
}